// Mirrors DenimCommon's InsuranceGridConstants - the set of valid values for
// an insurance grid entry's `value` (status) field.
export const insuranceStatusOptions = [
  { label: 'Schedule Allowed', value: 'Schedule Allowed' },
  { label: 'Established Patients', value: 'Established Patients' },
  { label: 'PCP Match', value: 'PCP Match' },
  { label: 'Credentialed', value: 'Credentialed' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Not Participating', value: 'Not Participating' },
  { label: 'No Status', value: 'No Status' },
  { label: 'Unknown', value: 'Unknown' },
];
